import emptyStateSvg from '@gitlab/svgs/dist/illustrations/empty-state/empty-service-desk-md.svg';
import { GlEmptyState, GlLink } from '@gitlab/ui';
import { isLoggedIn } from '~/lib/utils/common_utils';
import { __ } from '~/locale';
export default {
    name: 'EmptyStateWithoutAnyTickets',
    emptyStateSvg,
    components: {
        GlEmptyState,
        GlLink
    },
    inject: [
        'signInPath',
        'canAdminIssue',
        'isServiceDeskEnabled',
        'serviceDeskEmailAddress',
        'serviceDeskHelpPath'
    ],
    data () {
        return {
            isLoggedIn: isLoggedIn()
        };
    },
    computed: {
        canSeeEmailAddress () {
            return this.canAdminIssue && this.isServiceDeskEnabled;
        },
        primaryButtonLink () {
            return this.isLoggedIn ? undefined : this.signInPath;
        },
        primaryButtonText () {
            return this.isLoggedIn ? undefined : __('Register / Sign In');
        }
    }
};
